import { EntityTypes } from 'constants/entities';
import { IHistoryItem } from 'core/slices/register';
import { createSelector } from 'reselect';
import { RootState } from '../../../types';

// Narrowed to `register.history` rather than the whole register slice: this feeds
// the action feed, and taking all of `register` made every index/rendered/flag
// change rebuild the feed (and with it every slide) from scratch.
const registerHistory = (state: RootState) => state.register.history;
const courseProgressId = (state: RootState) => state.state[EntityTypes.COURSE_PROGRESS];

export const selectHistory = createSelector([registerHistory, courseProgressId], parseHistory);

export function parseHistory(history: IHistoryItem[], courseProgressId: number) {
  const filter = (item: IHistoryItem) => item.courseProgressId === courseProgressId;
  return history.filter(filter);
}
